export default {
  onlineOrder: {
    onlineSearchForm: {
      code: '',
      productId: 0,
      payType: 0,
      date:'',
      userTel: '',
      deadManCode: '',
      status: -1,
      remark: '',
      dateBack: ''
    },

    productList: [{
      areaName: '全部',
      areaId: 0
    }],

    payTypeList: [{
      areaName: '全部',
      areaId: 0
    }],

    orderStatusList: [{
      areaName: '全部',
      areaId: -1
    },{
      areaName: '已完成',
      areaId: 1
    },{
      areaName: '已退款',
      areaId: 2
    },{
      areaName: '退款中',
      areaId: 4
    },{
      areaName: '退款失败',
      areaId: 5
    }],
    
    pageManagement: {
      page: 1,
      size: 10,
      total: 0,
    },

    pageManagementV: {
      page: 1,
      size: 10,
      total: 0,
    },

    pageManagementLog: {
      page: 1,
      size: 10,
      total: 0,
    },

    number: '',

    totalList: [''],

    onlineSearchFormLog: {
      createUserName: '',
      content: '',
      date: ''
    },

    logList:[''],
    numberLog: "",
    
    title: 0
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/OnlineOrder/state.js